<h2 mat-dialog-title class="mat-dialog-title-offset">Replace Learner for Session</h2>
<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon"></div>
  </button>
</div>
<mat-dialog-content class="mat-typography modal-master-container tw:mx-2 tw:p-0">
  <div class="tw:w-full tw:p-12 content-container">
    <div class="tw:w-full student-search-modal-container">
      <student-search #studentSearch
                      [showFilters]="false"
                      [showClientFilter]="false"
                      [showAddButton]="true"
                      [triggerSearchOnLoad]="false"
                      [clientId]="searchData.clientId"
[excludeStudentIds]="searchData.excludeStudentIdsFromSearch"
                      [allocationSearch]="true"
                      [injectedShowSearch]="true"
                      (addStudent)="replaceStudent($event)"
                      [showPaginator]="false">
      </student-search>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="div-flex-buttons">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:py-4 tw:m-0 tw:w-full">
    <div class="tw:w-full tw:p-0 tw:m-0">
      <button mat-button [mat-dialog-close]="false" class="btn btn-primary tw:mx-1">Close</button>
    </div>
  </div>
</mat-dialog-actions>
